import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceDetailComponent } from "./price-detail.component";
import { ChartBarModule } from "libraries/component/chart-bar/chart-bar.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        PriceDetailComponent,
    ],
    imports: [
        CommonModule,
        ChartBarModule,
        BtnModule,
        FontAwesomeModule,
    ],
    exports: [
        PriceDetailComponent,
    ],
    providers: [],
})
export class PriceDetailModule {

}
